/**
 * Normalizes Unicode characters that differ between Node.js ICU data (server-side)
 * and browsers (client-side) to prevent SSR hydration mismatches.
 *
 * Known inconsistencies:
 * - U+2019 RIGHT SINGLE QUOTATION MARK used as thousands separator in de-CH by Node.js
 *   vs U+0027 APOSTROPHE used by some browsers
 * - U+202F NARROW NO-BREAK SPACE used as thousands separator in fr-CH by Node.js
 *   vs U+0020 SPACE used by some browsers
 */
const normalizeFormattedNumber = (value: string): string => value
  .replace(/\u2019/g, '\u0027')
  .replace(/\u202F/g, '\u0020');

export const useFormatCurrency = () => {

  const { n } = useI18n();

  const formatCurrency = (amount: number): string => normalizeFormattedNumber(n(amount, 'currency'));

  return { formatCurrency };

};
